import Reveal from "../../Reveal";
import SectionHeading from "../../SectionHeading";
import useSpotlight from "../../../../hooks/useSpotlight";
import { howItWorksSections } from "../../../../content/howItWorksSections";

/**
 * Single accordion entry. Built directly on <details>/<summary> (rather than
 * the shared SpotlightCard wrapper) so <summary> stays a direct child of
 * <details> and native disclosure behavior keeps working.
 * Translation: Single accordion entry. Built directly on <details>/<summary> (rather than
 * the shared SpotlightCard wrapper) so <summary> stays a direct child of
 * <details> and native disclosure behavior keeps working.
 *
 * @param {Object} props - FAQ item props.
 * @returns {JSX.Element} Accordion entry.
 */
const FaqItem = ({ item }) => {
  const { cardRef, handleMouseMove, handleMouseLeave } = useSpotlight();

  return (
    <details
      ref={cardRef}
      className="glass-panel spotlight-card hiw-faq-item"
      open={item.defaultOpen || undefined}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div className="spotlight-overlay">
        <div className="spotlight-gradient" />
      </div>
      <summary className="hiw-faq-item__summary">
        <span>{item.question}</span>
        <span className="hiw-faq-item__toggle" aria-hidden="true" />
      </summary>
      <div className="hiw-faq-item__answer">{item.answer}</div>
    </details>
  );
};

/**
 * FAQ accordion built on native details/summary elements.
 * Translation: FAQ accordion built on native details/summary elements.
 *
 * @returns {JSX.Element} FAQ section.
 */
const Faq = () => {
  const { faq } = howItWorksSections;

  return (
    <section id="faq" className="section-block">
      <div className="section-shell">
        <SectionHeading eyebrow={faq.eyebrow} title={faq.title} className="hiw-faq-heading" />

        <div className="hiw-faq-list">
          {faq.items.map((item, index) => (
            <Reveal key={item.question} delay={index * 60}>
              <FaqItem item={item} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
